import { render, staticRenderFns } from "./ADpageWithWxForm3.vue?vue&type=template&id=71933392&scoped=true&"
import script from "./ADpageWithWxForm3.vue?vue&type=script&lang=tsx&"
export * from "./ADpageWithWxForm3.vue?vue&type=script&lang=tsx&"
import style0 from "./ADpageWithWxForm3.vue?vue&type=style&index=0&id=71933392&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71933392",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/adlandingpage/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71933392')) {
      api.createRecord('71933392', component.options)
    } else {
      api.reload('71933392', component.options)
    }
    module.hot.accept("./ADpageWithWxForm3.vue?vue&type=template&id=71933392&scoped=true&", function () {
      api.rerender('71933392', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/willingADpages/ADpageWithWxForm3.vue"
export default component.exports